export const apiStatus = 'https://api.playbattlegrounds.com/status';
